import { QForm } from 'quasar';
import { Ref, ref } from 'vue';

import { OrganizationApi } from 'SharedDir/backend/api';
import { useNotifications } from 'SharedDir/common/composables/useNotifications';
import { makeRequest } from 'SharedDir/common/composables/useRequests';
import { MESSAGE_FORM_INVALID } from 'SharedDir/constants/messages';
import { OrganizationBare } from 'SharedDir/declarations/organization';
import { SystemUserIn } from 'SharedDir/declarations/user';
import { UserProfileBare } from 'SharedDir/declarations/user-profiles';

/**
 * Проверка на то, является ли данный профиль организацией
 * У нас в системе по факту 2 типа: Физическое лицо и организации
 *
 * @param userProfile
 */
export const isProfileOrganization = (userProfile: UserProfileBare | null) => {
  if (userProfile) {
    return userProfile?.organizationId !== null;
  }

  return false;
};

export const useProfileForm = (refForm: Ref<QForm | null> = ref(null)) => {
  const notify = useNotifications();

  const isOrganization = ref(false);

  const organizationFormData: Ref<OrganizationBare | null> = ref(null);

  const userFormData = ref<SystemUserIn | null>(null);

  const setData = (profile: UserProfileBare) => {
    isOrganization.value = isProfileOrganization(profile);

    if (isOrganization.value && profile.organization) {
      organizationFormData.value = profile.organization;
    } else {
      userFormData.value = profile.user;
    }
  };

  const setDataByProfile = (data: null | UserProfileBare) => {
    if (data) {
      setData(data);
    }
  };

  const save = async () => {
    if (!refForm.value) return;

    const isValid = await refForm.value.validate();
    if (!isValid) {
      notify.warningNotification(MESSAGE_FORM_INVALID);
      return;
    }

    if (isOrganization.value && organizationFormData.value) {
      await makeRequest(() => {
        return OrganizationApi.update(
          organizationFormData.value?.id as number,
          organizationFormData.value as OrganizationBare
        );
      });
    }
  };

  return {
    organizationFormData,
    userFormData,
    isOrganization,
    setData,
    setDataByProfile,
    save,
  };
};
